import React, { Component, Fragment } from 'react'

export default class Home extends Component {

    componentDidMount() {
        document.title = 'Apps by Kubernaughty™';
    }

    render () {
        return (
            <Fragment>
                <div id="heading">
                    <h1>Apps by Kubernaughty™</h1>
                </div>
                <section id="main" className="wrapper">
                    <div className="inner">
                        <div className="content">
                            <h3><b>Kubernaughty App Portfolio</b></h3>
                            <p>I'll eventually put an intro here.</p>
                            <p>If you have any issues with this site, <a href='https://i.kym-cdn.com/photos/images/original/001/207/210/b22.jpg'>check this help reference.</a>  Or just talk to Rob.  
                                He's probably right behind you.  No rights reserved.  Serve and enjoy.</p>
                        </div>
                    </div>
                </section>
            </Fragment>
        )
    }
}
